import { useTranslation } from 'react-i18next';
import { formatNumber } from '~/lib';

export default function PlanPrices({
  oldPrice,
  price,
  isSelected,
  period,
}: {
  oldPrice: string | number | null;
  price: string | number;
  isSelected: boolean;
  period: string;
}) {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;

  return (
    <div
      className={`flex justify-center gap-0.5x ${locale === 'ar' ? '' : 'flex-col'}`}
    >
      <span className="text-caption-2 text-[#666666E5] line-through">
        {formatNumber(Number(oldPrice ?? price))} {t('priceUnit')}
        {locale === 'en' && <span className="text-caption-2">{period}</span>}
      </span>
      <span
        className={` text-link-1 font-bold  ${
          isSelected ? 'text-blue' : 'text-black'
        }`}
      >
        {formatNumber(Number(price))} {t('priceUnit')}
        <span className="text-caption-2">{period}</span>
      </span>
    </div>
  );
}
